import service from '@/store/services/device-components-service';

const state = {
    list: {},
    deviceComponent: {},
    meta: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, deviceComponent) => {
        state.deviceComponent = deviceComponent;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((deviceComponent) => { commit('SET_RESOURCE', deviceComponent); });
    },

    checkComponent({ commit, dispatch }, params) {
        return service.checkComponent(params)
            .then((deviceComponent) => { commit('SET_RESOURCE', deviceComponent); });
    },

    replaceComponent({ commit, dispatch }, params) {
        return service.replaceComponent(params)
            .then((deviceComponent) => { commit('SET_RESOURCE', deviceComponent); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((deviceComponent) => { commit('SET_RESOURCE', deviceComponent); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    deviceComponent: state => state.deviceComponent,
    url: state => state.url
};

const deviceComponents = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default deviceComponents;